export const NotFound = () => {
    return (
      <div className="flex items-center justify-center w-full no-data-found">
        <p className="text-2xl font-semibold text-gray-600">No Data Found.</p>
      </div>
    );
  };
  